<template>
 <div v-if="series.length" class="sales-chart">
  <div v-for="s in series" :key="s.currency" class="mb-4">
   <div class="text-caption font-weight-bold mb-2">{{s.currency}}</div>
   <svg viewBox="0 0 600 210" role="img" :aria-label="'Monthly approved invoice sales in '+s.currency">
    <line v-for="y in [20,65,110,155]" :key="y" x1="48" :y1="y" x2="580" :y2="y" stroke="#E4E8F0" />
    <text x="3" y="24" fill="#8A93A6" font-size="10">{{compact(s.max)}}</text><text x="24" y="159" fill="#8A93A6" font-size="10">0</text>
    <polyline :points="s.points" fill="none" stroke="#2E56E8" stroke-width="2.5" />
    <g v-for="(r,i) in s.values" :key="r.month"><circle :cx="48+i*48" :cy="155-r.sales/s.max*135" r="3" fill="#2E56E8"><title>{{r.month}}: {{r.sales}} {{s.currency}}</title></circle><text v-if="i%2===0" :x="48+i*48" y="181" text-anchor="middle" fill="#8A93A6" font-size="10">{{r.month.slice(5)}}</text></g>
   </svg>
  </div>
 </div>
 <p v-else class="text-caption text-medium-emphasis py-12 text-center">No approved invoices in the last 12 months.</p>
</template>
<script setup>
import {computed} from 'vue';
const props=defineProps({rows:{type:Array,default:()=>[]}});
function compact(n){return new Intl.NumberFormat('en',{notation:'compact',maximumFractionDigits:1}).format(n);}
const series=computed(()=>[...new Set(props.rows.map(r=>r.currency))].map(currency=>{
 const filtered=props.rows.filter(r=>r.currency===currency);const now=new Date();
 const values=Array.from({length:12},(_,i)=>{const d=new Date(now.getFullYear(),now.getMonth()-11+i,1);const month=d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0');return {month,sales:Number(filtered.find(r=>r.month===month)?.sales||0)};});
 const max=Math.max(1,...values.map(r=>r.sales));return {currency,values,max,points:values.map((r,i)=>(48+i*48)+','+(155-r.sales/max*135)).join(' ')};
}));
</script>
<style scoped>svg{width:100%;display:block}.sales-chart{padding-top:16px}</style>
